import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { LogType } from '../../../helpers/enum';
import { TrackingService } from '../../../services/tracking.service';
import { visibleContentAnimation } from 'src/app/animations';
import { Helpers } from 'src/app/helpers/helpers';

@Component({
  selector: '[app-menu]',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [visibleContentAnimation]
})
export class MenuComponent implements OnInit {

  @Input() items!: any[];
  @Input() idparent: string;
  @Input() excludedLinkClass: string;

  currentInnerWidth: number;
  prevInnerWidth: number;
  currentUrl: string;

  isInDevEnvironment = true;

  constructor(
    private helper: Helpers,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.isInDevEnvironment = this.helper.isInDevEnvironment();
    this.currentUrl = this.router.url;

    this.router.events.subscribe(
      (event: RouterEvent) => {
        if (event instanceof NavigationEnd && this.router.url) {
          this.currentUrl = this.router.url;
          console.log(this.currentUrl);
        }
      }
    );
  }

  show_menu(el) {
    let el_link = el.querySelector('a[data-bs-toggle]');
    let el_btn = el.querySelector('.btn[data-bs-toggle]');

    if (el_btn) { el_link = el_btn; }

    if (el_link != null) {
      let nextEl = el_link.nextElementSibling;
      if (nextEl.classList.contains('dropdown-menu')) {
        el_link.classList.add('show');
        nextEl.classList.add('show');
      }

    }
  }

  hide_menu(el) {
    let el_link = el.querySelector('a[data-bs-toggle]');
    let el_btn = el.querySelector('.btn[data-bs-toggle]');

    if (el_btn) { el_link = el_btn; }

    if (el_link != null) {
      let nextEl = el_link.nextElementSibling;
      if (nextEl.classList.contains('dropdown-menu')) {
        el_link.classList.remove('show');
        nextEl.classList.remove('show');
      }
    }
  }

  isActiveLink(link: string | string[]): boolean {
    if (Array.isArray(link)) {
      return link.some(l => this.isActiveLink(l));
    }
    const tree = this.router.parseUrl(link);
    return this.router.isActive(tree, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored'
    });
  }

  getSubItemsUrls(subItems): string[] {
    return subItems.map(subItem => subItem.Url);
  }

  ngAfterViewInit() {
    this.currentInnerWidth = window.innerWidth;
    this.prevInnerWidth = this.currentInnerWidth;

    const that = this;

    if (!this.isInDevEnvironment) {
      window.addEventListener("resize", function () {
        that.currentInnerWidth = window.innerWidth;
        if ((that.prevInnerWidth > 992 && that.currentInnerWidth < 992) || (that.prevInnerWidth < 992 && that.currentInnerWidth > 992)) {
          that.prevInnerWidth = that.currentInnerWidth;
          window.location.reload();
        }
      });
    }

    document.querySelectorAll('.dropdown-menu').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    })

    if (window.innerWidth > 992) {

      const that = this;

      document.querySelectorAll('.dropdown').forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          if (el.classList.contains('hover')) {
            that.show_menu(el);
            this.parentElement.style.zIndex = "9999";
          }

        });
        el.addEventListener('mouseleave', function () {
          if (el.classList.contains('hover')) {
            that.hide_menu(el);
          }

        })
      });

    }
  }
}
